import { TemplateInterface } from '../../interfaces/template.interface';

export class LoadTemplatesSuccess {
    public static readonly type = '[DataCollection] Load templates success';

    constructor(public templates: Array<TemplateInterface>) { }
}
